import { Box, Skeleton } from "@mui/material"

interface TaskCalendarSkeletonProps {
  view?: 'week' | 'month'
}

export function TaskCalendarSkeleton({ view = 'week' }: TaskCalendarSkeletonProps) {
  if (view === 'week') {
    return (
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 0.5, height: 384 }}>
        {/* Header */}
        {[...Array(7)].map((_, i) => (
          <Box key={`header-${i}`} sx={{ p: 1, borderBottom: 1, borderColor: "divider", textAlign: "center" }}>
            <Skeleton variant="rounded" sx={{ height: 16, width: 32, mx: "auto", mb: 0.5 }} />
            <Skeleton variant="circular" sx={{ height: 32, width: 32, mx: "auto" }} />
          </Box>
        ))}

        {/* Calendar Body */}
        {[...Array(7)].map((_, i) => (
          <Box key={`day-${i}`} sx={{ p: 0.5, borderRight: 1, borderColor: "divider", minHeight: 300 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {/* Random number of tasks per day */}
              {[...Array(Math.floor(Math.random() * 3) + 1)].map((_, taskIndex) => (
                <Box
                  key={taskIndex}
                  sx={{ p: 1, borderRadius: 1, borderLeft: 4, borderLeftColor: "divider", bgcolor: "background.paper", boxShadow: 1 }}
                >
                  <Skeleton variant="rounded" sx={{ height: 16, width: "100%", mb: 0.5 }} />
                  <Skeleton variant="rounded" sx={{ height: 12, width: 48, borderRadius: 999 }} />
                </Box>
              ))}
              {Math.floor(Math.random() * 3) + 1 === 1 && (
                <Box sx={{ textAlign: "center", mt: 2 }}>
                  <Skeleton variant="rounded" sx={{ height: 12, width: 80, mx: "auto" }} />
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    )
  }

  // Month view skeleton
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 0.5 }}>
      {/* Header */}
      {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
        <Box key={day} sx={{ p: 1, fontWeight: 500, textAlign: "center", color: "text.secondary" }}>
          {day}
        </Box>
      ))}

      {/* Calendar Grid - 6 weeks */}
      {[...Array(42)].map((_, i) => (
        <Box
          key={i}
          sx={{ p: 1, minHeight: 100, border: 1, borderColor: "divider" }}
        >
          <Skeleton variant="rounded" sx={{ height: 16, width: 16, mb: 0.5 }} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            {/* Random tasks for some days */}
            {Math.random() > 0.6 && (
              <>
                <Box sx={{ p: 0.5, borderRadius: 1, borderLeft: 2, borderLeftColor: "divider", bgcolor: "background.paper" }}>
                  <Skeleton variant="rounded" sx={{ height: 12, width: "100%" }} />
                </Box>
                {Math.random() > 0.7 && (
                  <Box sx={{ p: 0.5, borderRadius: 1, borderLeft: 2, borderLeftColor: "divider", bgcolor: "background.paper" }}>
                    <Skeleton variant="rounded" sx={{ height: 12, width: "75%" }} />
                  </Box>
                )}
                {Math.random() > 0.8 && (
                  <Skeleton variant="rounded" sx={{ height: 12, width: 64 }} />
                )}
              </>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  )
}
